// Components==============
import PortfolioCard from 'components/UI/PortfolioCard/PortfolioCard';
import RecentActivity from 'components/UI/RecentActivity/RecentActivity';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { getDate } from 'utilities/getDate';
import { GlobalRecentActivitiesContext } from 'utilities/GlobalContext/GlobalRecentActivities';
import './SideMenu.module.scss';
// =========================

export default function SideMenu() {
  const recentActivities = useContext(GlobalRecentActivitiesContext);

  const translate = useTranslate();
  const userId = useRedux((state) => state.authentication?.user?.id);

  const portfolios = useRedux((state) =>
    state.portfolio?.entities.allIds
      .map((id) => state.portfolio?.entities.byId[id])
      .filter((portfolio) => portfolio?.created_by === userId)
      ?.sort((a, b) => getDate(b?.updated_at) - getDate(a?.updated_at))
  );

  // @ts-ignore
  const query = useMediaQ('min', 2000);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const activityRef = useRef<HTMLDivElement>(null);
  const portfolioRef = useRef<HTMLDivElement>(null);

  const [activityAmount, setActivityAmount] = useState(4);

  useLayoutEffect(() => {
    const wrapperHeight = wrapperRef.current?.clientHeight;
    const activityGroupHeight = activityRef.current?.clientHeight;
    const portfolioHeight = portfolioRef.current?.clientHeight || 0;
    const gapHeight = portfolioRef.current ? 32 : 0;
    const activityHeight = 75;

    if (wrapperHeight && activityGroupHeight) {
      const availableSpace =
        wrapperHeight - activityGroupHeight - portfolioHeight - gapHeight - 15;

      setActivityAmount(
        (prev) => prev + Math.floor(availableSpace / activityHeight)
      );
    }
  }, []);

  if (!recentActivities.activities?.length && !portfolios?.length) return <></>;

  return (
    <div styleName="wrapper" ref={wrapperRef}>
      {!!recentActivities.activities?.length && (
        <div ref={activityRef}>
          <h2>{translate('general.terms.latest-activities')}</h2>
          <div styleName="activities">
            {recentActivities?.activities
              ?.slice(0, activityAmount)
              .map((a, i) => (
                <RecentActivity activity={a!} key={i} />
              ))}
          </div>
        </div>
      )}
      {!!portfolios?.length && (
        <div ref={portfolioRef}>
          <h2>{translate('general.terms.my-portfolios')}</h2>
          <div styleName="portfolios">
            {portfolios?.slice(0, 3)?.map((portfolio) => (
              <PortfolioCard
                key={portfolio?.id}
                item={portfolio}
                width={query ? 280 : 220}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
